export default {
  loading: false,
  schema: null,
  data: {},
  id: null,
  viewEntityType: null
}



// WEBPACK FOOTER //
// ./src/store/modules/editor/state.js